module.exports = __webpack_public_path__ + "static/img/6.93ae512.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/sliders/7/6.jpg
// module id = W5al
// module chunks = 0